import { styled } from 'styled-components';

export const VerifyResetPasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ResendEmailWrapper = styled.div`
  margin-top: var(--spacing-10);
  text-align: center;
`;
